var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSparkle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 347,
    viewBox: "0 0 298 347",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_281_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.685 63.9531L130.232 84.277L149.392 89.5936L129.867 93.3545L124.7 113.328L121.153 93.004L101.993 87.6875L121.518 83.9266L126.685 63.9531Z",
    fill: "#EAF408"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.641 63.4373C129.398 62.0458 128.217 61.0122 126.806 60.9555C125.394 60.8987 124.135 61.8342 123.781 63.2017L119.088 81.3394L101.425 84.7416C100.057 85.005 99.051 86.1752 98.995 87.5669C98.939 88.9586 99.8483 90.2058 101.19 90.5782L118.524 95.3878L121.744 113.844C121.987 115.235 123.168 116.269 124.579 116.326C125.991 116.382 127.25 115.447 127.604 114.079L132.297 95.9417L149.96 92.5394C151.328 92.276 152.334 91.1058 152.39 89.7141C152.446 88.3224 151.537 87.0752 150.195 86.7028L132.862 81.8932L129.641 63.4373Z",
    stroke: "#CB37FF",
    strokeWidth: 6,
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_281_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.606 130.802L158.116 172.955L198.733 183.071L157.812 191.879L147.954 233.737L139.444 191.584L98.8265 181.467L139.748 172.66L149.606 130.802Z",
    fill: "#EAF408"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.527 130.011C153.155 128.168 151.55 126.833 149.671 126.803C147.791 126.772 146.144 128.055 145.713 129.885L136.434 169.281L97.9848 177.557C96.1657 177.948 94.8569 179.543 94.827 181.403C94.7971 183.264 96.0541 184.899 97.8597 185.349L136.024 194.854L144.033 234.528C144.405 236.371 146.01 237.706 147.889 237.736C149.769 237.766 151.416 236.483 151.847 234.654L161.126 195.257L199.575 186.982C201.394 186.59 202.703 184.996 202.733 183.136C202.763 181.275 201.506 179.64 199.7 179.19L161.536 169.684L153.527 130.011Z",
    stroke: "#EAF408",
    strokeWidth: 8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.527 130.011C153.155 128.168 151.55 126.833 149.671 126.803C147.791 126.772 146.144 128.055 145.713 129.885L136.434 169.281L97.9848 177.557C96.1657 177.948 94.8569 179.543 94.827 181.403C94.7971 183.264 96.0541 184.899 97.8597 185.349L136.024 194.854L144.033 234.528C144.405 236.371 146.01 237.706 147.889 237.736C149.769 237.766 151.416 236.483 151.847 234.654L161.126 195.257L199.575 186.982C201.394 186.59 202.703 184.996 202.733 183.136C202.763 181.275 201.506 179.64 199.7 179.19L161.536 169.684L153.527 130.011Z",
    stroke: "#CB37FF",
    strokeWidth: 8,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_281_3",
    x: 27.8669,
    y: 0.727504,
    width: 195.651,
    height: 197.626,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.9001
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.0629
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.79627 0 0 0 0 0.216423 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_281_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_281_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_281_3",
    x: 0.185204,
    y: 46.6634,
    width: 297.19,
    height: 300.217,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14.5026
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 45.3207
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.79627 0 0 0 0 0.216423 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_281_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_281_3",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle);
export default __webpack_public_path__ + "static/media/Sparkle.1eb681f7c1ce4258b06126fe480bfbde.svg";
export { ForwardRef as ReactComponent };